import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* createBatchMessageTemplate({ payload: { values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.sendbird.templates.create, data: values });

    onSuccess && onSuccess();
    yield put(actions.createBatchMessageTemplateDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.createBatchMessageTemplateFailed,
      handledErrors,
      endpoint: api.sendbird.templates.create.url
    });
  }
}

export const createBatchMessageTemplateSaga = takeEvery(types.CREATE_BATCH_MESSAGE_TEMPLATE_REQUEST, createBatchMessageTemplate);